
Array.prototype.sum = function(toNumber = (x) => x) {
    if (this.length === 0) {
        return 0
    }
    return this.map(toNumber).reduce((l, r) => l+r)
}

Array.prototype.removeAtIndex = function(index) {
    return [...this.slice(0, index), ...this.slice(index+1)]
}

Array.prototype.swapNoCopy = function(l, r) {
    const rep = this[l]
    this[l] = this[r]
    this[r] = rep
    return this
}

Array.prototype.swap = function(l, r) {
    const arr = this.slice()
    const rep = arr[l]
    arr[l] = arr[r]
    arr[r] = rep
    return arr
}

Array.prototype.unique = function() {
    return this.filter((value, index, ctx) =>
        ctx.indexOf(value) === index)
}

Array.prototype.smallest = function(f) {
    if (f) {
        return this.reduce((l, r) => f(l, r) ? l : r)
    }
    return this.reduce((l, r) => l<r ? l : r)
}

Array.prototype.max = function(f) {
    if (this.length === 0) {
        return null
    }
    if (f) {
        return this.reduce((l, r) => f(l, r) ? l : r)
    }
    return this.reduce((l, r) => l>r ? l : r)
}

const oldPartInt = Number.parseInt
Number.parseInt = function(x) {
    if (typeof x === 'number') {
        return Math.floor(x)
    }
    return oldPartInt(x)
}

Set.prototype.isSubset = function(set) {
    return [...this].every((val) => set.has(val))
}

